var map = {
	"./en/core.json": [
		1758,
		758
	],
	"./en/errors.json": [
		9158,
		158
	],
	"./en/faq.json": [
		5257,
		257
	],
	"./en/generic.json": [
		4910,
		910
	],
	"./en/guest.json": [
		4162,
		162
	],
	"./en/helps.json": [
		4136,
		136
	],
	"./en/validator.json": [
		2126,
		126
	],
	"./fr/chatbot.json": [
		8786,
		786
	],
	"./fr/core.json": [
		4964,
		964
	],
	"./fr/errors.json": [
		1966,
		966
	],
	"./fr/faq.json": [
		3525,
		525
	],
	"./fr/generic.json": [
		7056,
		56
	],
	"./fr/guest.json": [
		4029,
		29
	],
	"./fr/helps.json": [
		2966,
		147
	],
	"./fr/validator.json": [
		2581,
		581
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7535;
module.exports = webpackAsyncContext;